var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",on:{"click":_vm.handleClick}},_vm._l((_vm.options),function(option){return _c('div',{key:option.key,class:['option', { active: option.key === _vm.activeKey }],attrs:{"data-key":option.key}},[_vm._v("\n        "+_vm._s(option.label)+"\n    ")])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7f104d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropdownInput.vue
// module id = null
// module chunks = 